module.exports = __webpack_public_path__ + "img/4.298e132a.png";